import Section from '@app/components/atoms/Section/Section'
import DataGrid from '@app/components/organisms/DataGrid/DataGrid'
import { usePage } from '@inertiajs/inertia-react'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

export default function VoucherPos() {
  const {
    props: { pos, routeName, voucher, campaign_id },
  } = usePage()
  const { t } = useTranslation()

  return (
    <Section simple>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h5">{t('VOUCHER.POS')}</Typography>
        </Grid>
        <Grid item xs={12}>
          <DataGrid
            enableIndexColumn
            columns={[
              {
                id: 'address',
                Header: t('VOUCHER.ADDRESS'),
                accessor: 'address',
                type: 'string',
              },
              {
                id: 'city',
                Header: t('VOUCHER.CITY'),
                accessor: 'city',
                type: 'string',
              },
              {
                id: 'longitude',
                Header: t('VOUCHER.LONGITUDE'),
                accessor: 'longitude',
                type: 'string',
                disableFilters: true,
              },
              {
                id: 'latitude',
                Header: t('VOUCHER.LATITUDE'),
                accessor: 'latitude',
                type: 'string',
                disableFilters: true,
              },
            ]}
            data={pos}
            enableCollapseFilter={false}
            params={{ voucher: voucher.id, campaign: campaign_id }}
            queries={{ voucher: voucher.id, campaign: campaign_id }}
            routeName={routeName}
          />
        </Grid>
      </Grid>
    </Section>
  )
}
